<template>
  <div class="container shape-container d-flex" style="display: flex; flex-direction: column;">
    <!-- Part 1: Hero Image Slideshow -->
    <div ref="header_part" class=" pa-bo-50">
      <swiper :options="headerSwiperOptions" ref="headerSwiper">
        <swiper-slide v-for="(slide, index) in mainSlides" v-if="slide.active" :key="index">
          <a :href="slide.link" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                     class="content-image">
            <img :src="slide.image" style="cursor: pointer;" class="img-fluid rounded shadow" alt="Hero" />
          </a>
        </swiper-slide>
        <!-- Pagination Dots -->
        <div class="swiper-pagination"></div>
      </swiper>
    </div>

    <!-- Part 2: Button-based Navigation -->
    <h3 ref="lesson_part" class="p-4">Ангилалаар хайх</h3>
    <div ref="lesson_part" class="part-2 col-12 pa-bo-10">
      <Types :buttons="Typelist" />
    </div>

    <!-- Part 3 marked lesson -->
    <div class="title-part">
      <h3 class="p-4">Онцлох сургалт</h3>
      <div class="title-part-button">
        <div class="custom-swiper-button custom-swiper-button-prev" @click="moveSlide('prev', 'featuredSwiper')">
          <i class="fa fa-angle-left"></i>
        </div>
        <div class="custom-swiper-button" @click="moveSlide('next', 'featuredSwiper')">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </div>

    <div class="swiper-container part-2 col-12 pa-bo-50">
      <swiper ref="featuredSwiper" :options="swiperOptions">
        <swiper-slide v-for="(course, index) in lessonData" :key="index">
          <LessonCard :key="course.id" :data="course" userType="other" />
        </swiper-slide>
      </swiper>
    </div>

    <div ref="info_part" class="title-part">
      <h3 class="p-4">Зөвлөгөө, Мэдээлэл
      </h3>
      <div class="title-part-button">
        <div class="custom-swiper-button custom-swiper-button-prev" @click="moveSlide('prev', 'infoSwiper')">
          <i class="fa fa-angle-left"></i>
        </div>
        <div class="custom-swiper-button" @click="moveSlide('next', 'infoSwiper')">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </div>

    <div class="swiper-container part-2 col-12 pa-bo-50">
      <swiper ref="infoSwiper" :options="swiperOptions">
        <swiper-slide v-for="(course, index) in lessonDataZuvluguu" :key="index">
          <LessonCard :key="course.id" :data="course" userType="other" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- Part 4 teacher -->
    <div ref="teacher_part" class="title-part">
      <h3 class="p-4">Манай багш нар</h3>
      <div class="title-part-button">
        <div class="custom-swiper-button custom-swiper-button-prev" @click="moveSlide('prev', 'teacherSwiper')">
          <i class="fa fa-angle-left"></i>
        </div>
        <div class="custom-swiper-button" @click="moveSlide('next', 'teacherSwiper')">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </div>

    <div ref="teacher_part" class="swiper-container part-2 col-12 pa-bo-50">
      <swiper ref="teacherSwiper" :options="swiperOptions">
        <swiper-slide v-if="course.imageUrl" v-for="(course, index) in TeacherList" :key="index">
          <TeacherCard :key="course.id" :data="course" userType="other" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import "swiper/css/swiper.css";
import Types from "../components/lesson/Types.vue";
import LessonCard from '../components/lesson/LessonCard.vue';
import TeacherCard from '../components/lesson/TeacherCard.vue';
import axios from "axios";

export default {
  name: "MainPage",
  components: {
    Swiper,
    SwiperSlide,
    Types,
    LessonCard,
    TeacherCard,
  },
  data() {
    return {
      headerSwiperOptions: {
        loop: true,
        autoplay: {
          delay: 3000, // 3 seconds
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      swiperOptions: {
        // slidesPerView: 2,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: { slidesPerView: 3, spaceBetween: 30 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          640: { slidesPerView: 1, spaceBetween: 10 },
        },
      },
      lessonData: [],
      lessonDataZuvluguu: [],
      Typelist: [
        { name_mgl: 'Lessons', value: 'lessons' },
        { name_mgl: 'Courses', value: 'courses' },
        { name_mgl: 'About', value: 'about' },
      ],
      TeacherList: [],
      mainSlides: [],
    };
  },
  mounted() {
    this.fetchTypeDetails();
    this.fetchLessonData();
    this.fetchTeacherDetails();
    this.fetchLessonDataZuvluguu();
    this.fetchCatalogDetails();
  },
  watch: {
    '$route.query.catalog'(newCatalog) {
      if (newCatalog) {
        this.scrollToSection(newCatalog);
      }
    }
  },
  methods: {
    navigate(page) {
      this.$router.push(`/${page}`);
    },
    handleScrollToSection(sectionRef) {
      this.scrollToSection(sectionRef);
      console.log('page', sectionRef);
    },
    scrollToSection(refName) {
      this.$nextTick(() => {
        const section = this.$refs[refName];
        if (section) {
          let topOffset = 206;  // You can adjust this value
          if (refName == 'info_part')
            topOffset = 106;
          const topPosition = section.getBoundingClientRect().top + window.pageYOffset - topOffset;

          window.scrollTo({
            top: topPosition,
            behavior: 'auto'  // Instant scroll without smooth behavior
          });
        }
      });
    },
    async fetchTypeDetails() {
      try {
        const response = await axios.get(`/lessons/types`);
        this.Typelist = response.data;
      } catch (error) {
        console.error("Failed to load lesson types:", error);
      }
    },
    async fetchCatalogDetails() {
      try {
        const response = await axios.get(`/catalog_list`);
        this.mainSlides = response.data;
      } catch (error) {
        console.error("Failed to load Catalog details:", error);
      }
    },

    handleSlideClick(link) {
      if (link) {
        window.location.href = link;
      }
    },

    async fetchTeacherDetails() {
      try {
        const response = await axios.get(`/teachers`);
        this.TeacherList = response.data;
      } catch (error) {
        console.error("Failed to load teacher details:", error);
      }
    },
    async fetchLessonData() {
      try {
        const response = await axios.get("/lessons", {
          params: { skip: 0, limit: 10, lesson_type: "ontsloh" },
        });
        this.lessonData = response.data.items || [];
      } catch (error) {
        console.error("Error fetching lessons:", error);
      }
    },
    async fetchLessonDataZuvluguu() {
      try {
        const response = await axios.get("/lessons", {
          params: { skip: 0, limit: 10, lesson_type: "zuvluguu" },
        });
        this.lessonDataZuvluguu = response.data.items || [];
      } catch (error) {
        console.error("Error fetching lessons:", error);
      }
    },
    moveSlide(direction, swiperRef) {
      const swiper = this.$refs[swiperRef].$swiper;
      if (direction === 'prev') swiper.slidePrev();
      if (direction === 'next') swiper.slideNext();
    },
  },
};
</script>

<style scoped>
/* Button Group Styling */
.btn-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

/* Card Styling */
.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: center;
}

.card-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

/* Swiper Navigation Buttons */
.swiper-button-prev,
.swiper-button-next {
  color: #000;
}

.title-part {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.title-part-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 16px;
  gap: 10px;
}

.custom-swiper-button {
  position: relative;
  width: 30px;
  height: 30px;
  /* background-color: rgba(0, 0, 0, 0.5); */
  color: black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.3s ease;
}

.custom-swiper-button:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.swiper-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pa-bo-10 {
  padding-bottom: 10px;
}

.pa-bo-50 {
  padding-bottom: 50px;
}

.content-image img {
  width: 100%;
  height: 350px;
  /* Set a consistent height */
  object-fit: cover;
  /* Ensure the image covers the container */
  object-position: top;
  /* Crop the bottom part */
  border-radius: 10px;
  transition: opacity 0.5s ease;
}

/* Pagination Dots */
.swiper-pagination {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 10;
}

.swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #007bff;
  opacity: 0.5;
  margin: 0 5px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.swiper-pagination-bullet-active {
  background-color: #0056b3;
  opacity: 1;
}

@media (max-width: 768px) {
  .content-image img {
    height: 220px;
  }

  .container {
    padding-right: 0 !important;
  }
}

@media (max-width: 480px) {
  .content-image img {
    height: 160px;
  }

  .container {
    padding-right: 0 !important;
  }
}
</style>
